import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { map, startWith, take } from 'rxjs/operators';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { MyErrorStateMatcher } from 'src/app/util/my-error-state-matcher';
import { RuleConfig } from '../../model/rule-config';
import { RuleConfigService } from '../../service/rule-config.service';
import * as moment from 'moment';
import { FormuleConfig } from 'src/app/views/formule-config/model/FormuleConfig';
import { FormuleConfigService } from 'src/app/views/formule-config/service/formule-config.service';
import { TableDTO } from '../../model/table-dto';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-rule-config-add',
  templateUrl: './rule-config-add.component.html',
  styleUrls: ['./rule-config-add.component.scss']
})
export class RuleConfigAddComponent implements OnInit {

  form: FormGroup;
  matcher: any;
  user: string = '';
  isEdit: boolean = false;
  isOff: boolean = false;
  objEdit: RuleConfig;
  formuleList: FormuleConfig[] = [];
  tableList: TableDTO[] = [];
  columnOriginList: string[] = [];
  columnDestinationList: string[] = [];
  tableColumnDestinationList: any[] = [];
  tableColumnOriginList: any[] = [];

  filteredOptions: Observable<TableDTO[]>;
  filteredOptionsTableDestination: Observable<TableDTO[]>;
  filteredOptionsFormule: Observable<FormuleConfig[]>;

  filteredOptionsColumnOrigin: Observable<string[]>;
  filteredOptionsColumnDestination: Observable<string[]>;

  filteredOptionsTableColumnOrigin: Observable<any[]>;
  filteredOptionsTableColumnDestination: Observable<any[]>;

  constructor(private _fb: FormBuilder,
    private router: Router,
    private notificationService: NotificationService,
    private service: RuleConfigService,
    private serviceFormuleConfig: FormuleConfigService,
    private route: ActivatedRoute,
    private generalService: GeneralService) { }

  ngOnInit(): void {
    this.createForm();
    this.isCheckEdit();
  }

  getUserName = async () => {
    await this.generalService
      .getUserNameValue()
      .pipe(take(1))
      .toPromise()
      .then((name: string) => {
        this.user = name;
      });
  };

  createForm = () => {
    this.form = this._fb.group({
      id: [null],
      name: [null, Validators.required],
      formule: [null, Validators.required],
      table_origin: [null, Validators.required],
      table_destination: [null, Validators.required],
      column_origin: [null, Validators.required],
      column_destination: [null, Validators.required],
      origin_relationship: [null, Validators.required],
      destination_relationship: [null, Validators.required]
 
    });

    this.filterAutoComplete();
  };

  getFormuleList = async() => {
    await this.serviceFormuleConfig.getList(null)
    .then(node => this.formuleList = node)
    .catch(err => console.error(err));
  }

  getTableList = async() => {
    await this.service.getTableList()
    .then(node => this.tableList = node)
    .catch(err => console.error(err));
  }

  back() {
    this.router.navigateByUrl('/rule-config');
  }

  isCheckEdit = () => {
    this.route.paramMap.subscribe(async (paramMap) => {
      await this.getFormuleList();
      await this.getTableList();

      let id = paramMap.get('id');
      let off = paramMap.get('off');

      if (off !== 'undefined' && off !== 'false') {
        this.isOff = true;
      }

      if (id !== undefined && id !== null) {
        this.isEdit = true;
        if (!this.isOff) {
          await this.getById(Number(id));
        } else {
          await this.getByIdOff(id);
        }
      }

      await this.getUserName();
    });
  };

  populateFormEdit = (obj: RuleConfig) => {
    this.objEdit = obj;
    this.form.controls.id.setValue(obj.id);
    this.form.controls.name.setValue(obj.name);
    this.form.controls.formule.setValue(obj.formule_config_id);
    this.form.controls.table_origin.setValue(obj.table_origin);
    this.form.controls.table_destination.setValue(obj.table_destination);
    this.form.controls.column_origin.setValue(obj.column_origin);
    this.form.controls.column_destination.setValue(obj.column_destination);
    this.form.controls.origin_relationship.setValue(obj.origin_relationship);
    this.form.controls.destination_relationship.setValue(obj.destination_relationship);

    this.getColumnTableOriginList();
    this.getColumnTableDestinationList();
  };

  getByIdOff = async (name: string) => {
    const data_offline = await this.generalService.getDataFromLocalStorage('rule-config');
    if (data_offline?.length > 0) {
      let formuleConfig = data_offline.find(a => a.name === name);
      this.populateFormEdit(formuleConfig);
    }
  }

  getById = async (id: number) => {
    await this.service
      .getById(id)
      .then((node) => {
        this.populateFormEdit(node[0]);
      })
      .catch((err) => console.error(err));
  };

  populateModel = () => {
    let obj = new RuleConfig();

    if (!this.isEdit) {
      obj.created_at = moment(new Date()).format('YYYY-MM-DD');
      obj.user_created = this.user;
      obj.active = true;
    } else {
      obj.created_at = this.objEdit.created_at;
      obj.user_created = this.objEdit.user_created; 
      obj.active = this.objEdit.active;     
    }

    obj.id = this.form.controls.id.value;
    obj.updated_at = moment(new Date()).format('YYYY-MM-DD');
    obj.name = this.form.controls.name.value;
    obj.column_origin = this.form.controls.column_origin.value;
    obj.table_origin = this.form.controls.table_origin.value;
    obj.table_destination = this.form.controls.table_destination.value;
    obj.column_destination = this.form.controls.column_destination.value;
    obj.formule_config_id = this.form.controls.formule.value.id;
    obj.user_updated_at = this.user;
    obj.origin_relationship = this.form.controls.origin_relationship.value;
    obj.destination_relationship = this.form.controls.destination_relationship.value;

    return obj;
  };

  saveAll = () => {
    if (this.isOff) {
      this.saveOff();
    } else {
      this.save();
    }
  }

  saveOff = async() => {
    this.matcher = new MyErrorStateMatcher();
    const data_offline = await this.generalService.getDataFromLocalStorage('formule-config');
    if (this.form.valid) {
      let obj = this.populateModel();
      obj.isOff = true;
      if (this.isEdit) {
        let listOff:RuleConfig[] = data_offline.filter(a => a.name !== this.objEdit.name);        
        listOff.push(obj);
        localStorage.setItem('data_formule-config', JSON.stringify(listOff));
        this.notificationService.sendNotification(
          null,
          TypeMessage.Edit,
          ActionMessage.Success
        );
      } else {
        data_offline.push(obj);
        localStorage.setItem('data_formule-config', JSON.stringify(data_offline));
        this.notificationService.sendNotification(
          null,
          TypeMessage.New,
          ActionMessage.Success
        );
      }

      this.back();
     } else {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Warning
      );
     }
  }

  save() {
    this.matcher = new MyErrorStateMatcher();

    if (this.form.valid) {
      let obj = this.populateModel();
      this.service
        .saveOrUpdate(obj)
        .then((res) => {
          if (!this.isEdit) {
            this.notificationService.sendNotification(
              null,
              TypeMessage.New,
              ActionMessage.Success
            );
          } else {
            this.notificationService.sendNotification(
              null,
              TypeMessage.Edit,
              ActionMessage.Success
            );
          }

          this.back();
        })
        .catch((err) => console.error(err));
    } else {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Warning
      );
    }
  }

  getColumnTableOriginList = async() => {
    let input = this.form.controls.table_origin.value;
    let tableReplace = input.replace("_", " ");
    let tableCapitalize = this.capitalizeFirstLetter(tableReplace);
    let tableSend = tableCapitalize.replace(" ", "");
    await this.service.getColumnList(tableSend)
    .then(node => this.columnOriginList = node)
    .catch(err => console.error(err));
  }

  getColumnTableDestinationList = async() => {
    let input = this.form.controls.table_destination.value;
    let tableReplace = input.replace("_", " ");
    let tableCapitalize = this.capitalizeFirstLetter(tableReplace);
    let tableSend = tableCapitalize.replace(" ", "");
    await this.service.getColumnList(tableSend)
    .then(node => this.columnDestinationList = node)
    .catch(err => console.error(err));
  }

  capitalizeFirstLetter(string): string {
    const arr = string.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }

    const str2 = arr.join(" ");
    return str2;
  }

  filterAutoComplete = () => {
    this.filteredOptionsFormule = this.form.controls.formule.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value.name),
      map(name => name ? this._filterFormule(name) : this.formuleList.slice())
    );

    this.filteredOptions = this.form.controls.table_origin.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );

    this.filteredOptionsTableDestination = this.form.controls.table_destination.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );

    this.filteredOptionsColumnOrigin = this.form.controls.column_origin.valueChanges.pipe(
      startWith(''),
      map(value => this._filterColumnOrigin(value))
    );

    this.filteredOptionsColumnDestination = this.form.controls.column_destination.valueChanges.pipe(
      startWith(''),
      map(value => this._filterColumnDestination(value))
    );
    
    this.filteredOptionsTableColumnOrigin = this.form.controls.origin_relationship.valueChanges.pipe(
      startWith(''),
      map(value => this._filterOriginRelationship(value))
    );

    this.filteredOptionsTableColumnDestination = this.form.controls.destination_relationship.valueChanges.pipe(
      startWith(''),
      map(value => this._filterDestinationRelationship(value))
    );
  }

  private _filterFormule(value: string): FormuleConfig[] {
    const filterValue = value.toLowerCase();

    return this.formuleList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  private _filter(value: string): TableDTO[] {
    const filterValue = value.toLowerCase();

    return this.tableList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  private _filterColumnOrigin(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.columnOriginList.filter(option => option.toLowerCase().includes(filterValue));
  }

  private _filterColumnDestination(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.columnDestinationList.filter(option => option.toLowerCase().includes(filterValue));
  }

  private _filterOriginRelationship(value: string): any[] {
    const filterValue = value.toLowerCase();

    return this.tableColumnOriginList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  private _filterDestinationRelationship(value: string): any[] {
    const filterValue = value.toLowerCase();

    return this.tableColumnDestinationList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayFn(formule: FormuleConfig): string {
    return formule && formule.name ? formule.name : '';
  }

}
